//Pseudo enums
export const gamestates = {
    PlayerSelect: 0,
    Game: 1,
}

export const roundstates = {
    Storm: 0,
    Repair: 1,
    Calendar: 2,
    ChooseOption: 3,
    RoundReport: 4,
    RollTheDice: 5,
    EndOfRound: 6,
}

export enum SubMenu {
    
    main = 0,
    sellAndMove = 1,
    sellAndMoveElsewhere = 2,
    raiseABuilding = 3,
    relocateABuilding = 4,
    relocateUrupa = 5,
    protectPropertiesAndCommunity = 6,
    protectPropertiesAndCommunityRiver = 7,
    protectPropertiesAndCommunitySea = 8,

    //    buyInvestmentProperty = 1,
    //    sellInvestmentProperty = 3,
}
